module.exports = __webpack_public_path__ + "img/damages.371acf12.webp";